<ngx-spinner></ngx-spinner>
<div class="page-header">
  <div class="d-flex align-items-center justify-content-between mb-4">
    <div class="page-title">
      <h1 class="fs-4 fw-bold mb-0">Edit {{page?.title}}</h1>
      <div class="back-link my-2">
      <a  *ngIf="type=='offers_sections'" routerLink="/content-manager/offers"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <polyline points="15 6 9 12 15 18" />
      </svg>back to Offers</a>
      <a  *ngIf="type=='baymount_statistics' || type=='baymount_map' || type=='baymount_masterplan' || type=='baymount_partners'" routerLink="/page-manager/page/24"><svg  class="icon icon-tabler icon-tabler-chevron-left" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <polyline points="15 6 9 12 15 18" />
      </svg>back to Offers</a>
      </div>
    </div>
    <div class="last-update-text">
      <!-- Last Updated: 24 hrs ago • Updated by: Admin Name -->
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="d-flex align-items-center ">
        <span class="me-2">Go to: </span>
        <mat-list class="list" role="list">
          <mat-form-field appearance="outline">
            <mat-label>Select an item</mat-label>
            <mat-select [(value)]="selectedItem" (selectionChange)="scrollToSection($event)">
              <!-- <mat-option>None</mat-option> -->
              <mat-option *ngFor="let SECTION of dataSection" [value]="SECTION.id">
                {{SECTION.section_name| replace:'[_]': ' '}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-list>


      </div>
    </div>
    <div class="col-6">
      <div class="btn-group ms-auto" role="group">
        <!-- <button type="button" class="btn btn-primary" (click)="lang = 'comm'" [ngClass]="{ selected:  lang=='comm' }">
          Common Info
        </button> -->
        <button type="button" class="btn btn-primary" (click)="lang = 'en'" [ngClass]="{ selected: lang=='en' }">
          English Editor
        </button>
        <button type="button" class="btn btn-primary" (click)="lang = 'ar'" [ngClass]="{ selected:  lang=='ar'}">
          Arabic Editor
        </button>
      </div>
    </div>
  </div>
</div>
<!-- successful header -->

<section class="py-2">
  <div class="header-search-table">
    <div class="row">
      <div class="accordion accordion-flush" id="accordionFlushExample">
        <div class="accordion-item" id="{{'section_'+section_index}}"
          *ngFor="let SECTION of dataSection; let section_index=index;">
          <div class="accordion-header d-flex justify-content-between align-items-center" id="flush-headingOne">
            <button class="accordion-button  collapsed w-auto" (click)="viewOnly()" type="button"
              data-bs-toggle="collapse" [attr.data-bs-target]="'#' + 'collapse' + SECTION.id" aria-expanded="false"
              [attr.aria-controls]="'collapse' + SECTION.id">
              <div class="plus-minus-toggle"></div>
              {{SECTION.section_name|uppercase| replace:'[_]': ' '}}
            </button>
            <div class="d-flex align-items-center">
              <!-- <div class="d-flex align-items-center me-4">
                <span class="section-vis  me-3">Section Visibility:</span>
                <div class="input-toggle">
                  <fieldset>
                    <label class="input-toggle-label d-inline-block" for="switch{{SECTION.id}}">
                      <input type="checkbox" id="switch{{SECTION.id}}" value="{{SECTION.is_visible}}"
                        (change)="checkBoxvalue($event.target.checked, SECTION.id )"
                        [checked]="SECTION.is_visible == 1">
                      <span class="switch"></span>
                    </label>
                  </fieldset>
                </div>
              </div> -->
              <div class="edit-section">
                <!-- <button (click)="viewAndEdit()" class="btn_default collapsed" type="button" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#' + 'collapse' + SECTION.id" aria-expanded="false"
                  [attr.aria-controls]="'collapse' + SECTION.id">Edit
                  Section</button> -->
                  <button type="button" *ngIf="SECTION.type!='none'"class="btn_default collapsed" type="button" data-bs-toggle="collapse" [routerLink]="'/content-manager/list/'+SECTION.section_name+'/'+SECTION.id">
                    Edit Slider
                  </button>
              </div>
            </div>

          </div>
          <div id="collapse{{SECTION.id}}" class="accordion-collapse collapse"
            [attr.aria-labelledby]="'heading' + SECTION.id" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">




              <div class="section-details" *ngIf="dataSection!=null">
                <div class="form-group">

                  <form [formGroup]="forms[section_index]">
                    <div class="row pe-5 " *ngIf="lang=='comm'">
                      <!-- Render Common Fields -->
                      <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.common; let i = index"
                        [ngClass]="{'d-none': toggleShow[section_index][field.name]==false}">
                        <div *ngIf="field.type != 'hidden'">
                          <label class="form-control-label" [ngClass]="{ required: field.required }"
                            [attr.for]="field.label">
                            {{ field.label }}:
                          </label>

                          <div [ngSwitch]="field.type">
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'">
                              <input matInput placeholder="" formControlName="{{field.name}}" />
                            </mat-form-field>
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'">
                              <select matInput class="form-control" [id]="field.name" [formControlName]="field.name">
                                <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                              </select>
                            </mat-form-field>
                            <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">

                              <quill-editor formControlName="{{field.name}}"></quill-editor>
                            </div>
                            <div *ngSwitchCase="'radio'">
                              <div class="form-check" *ngFor="let opt of field.options">
                                <input class="form-check-input" (change)="updateRadioButton(field.name,section_index )"
                                  formControlName="{{field.name}}" type="radio" [value]="opt.key">
                                <label class="form-check-label">
                                  {{opt.label}}
                                </label>
                              </div>
                            </div>
                            <div class="img-field" *ngSwitchCase="'file'">

                              <input type="file" (change)="upload($event, field.name,section_index)" hidden
                                id="{{field.name+'-'+section_index}}" accept="image/png,image/jpg, image/gif, image/jpeg, image/webp" />
                              <div class="table_image" (click)="triggerClick(field.name+'-'+section_index)"
                                [ngClass]="{'replace-img': imageSrc[field.name][section_index]!=imageUrl+'null'}">
                                <img [src]='renderImage(field.name,section_index)'
                                  *ngIf="!imageSrc && !vaildationImageSize" class="img_fit" />

                                <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name][section_index])" class="img_fit"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null' " />
                                <img src="assets/images/no-image-placeholder.png"
                                  *ngIf="imageSrc[field.name][section_index]==imageUrl+'null' " class="img-fluid" />
                                <div class="text-replace-img"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null'">
                                  Replace image
                                </div>
                              </div>
                            </div>

                            <!-- <small *ngIf="imageSizeError[section_index][field.name]  && field.type=='file'"
                              class="text-danger font-14">The image size must not exceed 3MB</small> -->
                            <small
                              *ngIf=" !forms[section_index].controls[field.name].valid && forms[section_index].controls[field.name].touched "
                              class="text-danger font-14">You must enter {{ field.label }}.</small>
                            <small *ngIf=" backendErrors[section_index][field.name]"
                              class="text-danger font-14">{{backendErrors[section_index][field.name]}}</small>
                          </div>
                        </div>
                      </div>

                    </div>











                    <div class="row pe-5" *ngIf="lang=='en'">
                      <!-- Render English Fields -->

                      <div class="field col-md-6"
                       [ngClass]="{'d-none': toggleShow[section_index][field.name]==null||toggleShow[section_index][field.name]==''  }"
                        *ngFor="let field of contentTypeData.edit_form.english; let i = index">
                        <div *ngIf="field.type != 'hidden'">
                          <label class="form-control-label" [ngClass]="{ required: field.required }"
                            [attr.for]="field.label" *ngIf="(field.type!='radio')">
                            {{ field.label }}:
                          </label>

                          <div [ngSwitch]="field.type">
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'">
                              <input matInput placeholder="" formControlName="{{field.name}}" />

                            </mat-form-field>
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'">
                              <select matInput class="form-control" [id]="field.name" [formControlName]="field.name">
                                <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                              </select>
                            </mat-form-field>
                            <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">

                              <quill-editor formControlName="{{field.name}}"></quill-editor>
                            </div>

                            <div *ngSwitchCase="'radio'">
                              <div *ngIf="!((field.name=='is_media_different' && forms[section_index].get('media').value== null)||
                              (field.name=='is_icon_different' && forms[section_index].get('icon').value== null)||
                              (field.name=='is_dark_image_different' && forms[section_index].get('dark_image').value== null))">
                              <label class="form-control-label" [ngClass]="{ required: field.required }"
                            [attr.for]="field.label">
                            {{ field.label }}:
                          </label>
                              <div class="form-check" *ngFor="let opt of field.options">
                                <input class="form-check-input" formControlName="{{field.name}}"
                                  (change)="updateRadioButton(field.name,section_index,opt.key)" type="radio"
                                  [value]="opt.key">
                                <label class="form-check-label">
                                  {{opt.label}}
                                </label>
                              </div>
                            </div>
                            </div>

                            <div class="img-field" *ngSwitchCase="'file'" >
                          
                              <input type="file" (change)="upload($event, field.name,section_index)" hidden
                                id="{{field.name+'-'+section_index}}" accept="image/png, image/gif, image/jpeg, image/jpg, image/webp, video/mp4,video/x-m4v,video/*" />
                              <div class="table_image" (click)="triggerClick(field.name+'-'+section_index)"
                                [ngClass]="{'replace-img': imageSrc[field.name][section_index]!=imageUrl+'null'}">

                                <img [src]='renderImage(field.name,section_index)'
                                  *ngIf="!imageSrc && !vaildationImageSize" class="img_fit" />
                                  <div *ngIf="fileType[field.name][section_index]=='image'">
                                <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name][section_index])" class="img_fit"
                                  *ngIf="
                                   imageSrc[field.name][section_index]!=imageUrl+'null'
                                  || imageSrc[field.name][section_index]!=imageUrl+'NULL'  " />
                                </div>

                                  <video  class="img-fluid"  controls [src]="imageSrc[field.name][section_index]"
                                  *ngIf="imageSrc[field.name][section_index]!='null' &&
                                  fileType[field.name][section_index]==='video'" >
                                    Your browser does not support the video tag.
                                  </video>

                                <img src="assets/images/no-image-placeholder.png"
                                  *ngIf="imageSrc[field.name][section_index]==imageUrl+'null'
                                  || imageSrc[field.name][section_index]==imageUrl+'NULL'" class="img-fluid" />

                                <div class="text-replace-img"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null' || imageSrc[field.name][section_index]!=imageUrl+'NULL' ">
                                  Replace image
                                </div>
                              </div>
                              <small *ngIf="imageSizeError[field.name][section_index] && field.type=='file'"
                                class="text-danger font-14">The image size must not exceed 3MB</small>


                              <small *ngIf=" field.type=='file'&& fileType[field.name][section_index]=='image'"
                                class="text-danger font-14">{{SECTION.media_dimensions}}</small>
                            </div>

                            <small
                              *ngIf=" !forms[section_index].controls[field.name].valid && forms[section_index].controls[field.name].touched "
                              class="text-danger font-14">You must enter {{ field.label }}.</small>
                            <small *ngIf=" backendErrors[section_index][field.name]"
                              class="text-danger font-14">{{backendErrors[section_index][field.name]}}</small>

                          </div>
                        </div>
                      </div>

                    </div> <!-- End of Render English Fields -->













                    <div class="row pe-5 " *ngIf="lang=='ar'">
                      <!-- Render Arabic Fields -->
                      <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.arabic; let i = index"
                        [ngClass]="{'d-none': toggleShow[section_index][field.name]==false}">
                        <div *ngIf="field.type != 'hidden'">
                          <label class="form-control-label" [ngClass]="{ required: field.required }"
                            [attr.for]="field.label">
                            {{ field.label }}:
                          </label>

                          <div [ngSwitch]="field.type">
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'">
                              <input matInput placeholder="" formControlName="{{field.name}}" />
                            </mat-form-field>
                            <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'">
                              <select matInput class="form-control" [id]="field.name" [formControlName]="field.name">
                                <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                              </select>
                            </mat-form-field>

                            <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">

                              <quill-editor formControlName="{{field.name}}"></quill-editor>
                            </div>
                            <div *ngSwitchCase="'radio'">
                              <div class="form-check" *ngFor="let opt of field.options">
                                <input class="form-check-input" formControlName="{{field.name}}" type="radio"
                                  (change)="updateRadioButton(field.name,section_index)" [value]="opt.key">
                                <label class="form-check-label">
                                  {{opt.label}}
                                </label>
                              </div>
                            </div>
                            <!-- <div class="img-field" *ngSwitchCase="'file'">

                              <input type="file" (change)="upload($event, field.name,section_index)" hidden
                                id="{{field.name+'-'+section_index}}" accept="image/png, image/gif, image/jpeg" />
                              <div class="table_image" (click)="triggerClick(field.name+'-'+section_index)"
                                [ngClass]="{'replace-img': imageSrc[field.name][section_index]!=imageUrl+'null'}">
                                <img [src]='renderImage(field.name,section_index)'
                                  *ngIf="!imageSrc && !vaildationImageSize" class="img_fit" />

                                <img [src]="imageSrc[field.name][section_index]"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null' " class="img_fit" />

                                <img src="assets/images/no-image-placeholder.png"
                                  *ngIf="imageSrc[field.name][section_index]==imageUrl+'null' " class="img-fluid" />
                                <div class="text-replace-img"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null'">
                                  Replace image
                                </div>
                              </div>
                            </div> -->
                           <div class="img-field" *ngSwitchCase="'file'" >
                              <input type="file" (change)="upload($event, field.name,section_index)" hidden
                                id="{{field.name+'-'+section_index}}" accept="image/png, image/gif, image/jpeg, image/jpg, image/webp, video/mp4,video/x-m4v,video/*" />
                              <div class="table_image" (click)="triggerClick(field.name+'-'+section_index)"
                                [ngClass]="{'replace-img': imageSrc[field.name][section_index]!=imageUrl+'null'}">

                                <img [src]='renderImage(field.name,section_index)'
                                  *ngIf="!imageSrc && !vaildationImageSize" class="img_fit" />
                                  <div *ngIf="fileType[field.name][section_index]=='image'">
                                <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name][section_index])" class="img_fit"
                                  *ngIf="
                                   imageSrc[field.name][section_index]!=imageUrl+'null'
                                  || imageSrc[field.name][section_index]!=imageUrl+'NULL'  " />
                                </div>

                                  <video  class="img-fluid"  controls [src]="imageSrc[field.name][section_index]"
                                  *ngIf="imageSrc[field.name][section_index]!='null' &&
                                  fileType[field.name][section_index]==='video'" >
                                    Your browser does not support the video tag.
                                  </video>

                                <img src="assets/images/no-image-placeholder.png"
                                  *ngIf="imageSrc[field.name][section_index]==imageUrl+'null'
                                  || imageSrc[field.name][section_index]==imageUrl+'NULL'" class="img-fluid" />

                                <div class="text-replace-img"
                                  *ngIf="imageSrc[field.name][section_index]!=imageUrl+'null' || imageSrc[field.name][section_index]!=imageUrl+'NULL' ">
                                  Replace image
                                </div>
                              </div>
                              <small *ngIf="imageSizeError[field.name][section_index] && field.type=='file'"
                                class="text-danger font-14">The image size must not exceed 3MB</small>


                              <small *ngIf=" field.type=='file'&& fileType[field.name][section_index]=='image'"
                                class="text-danger font-14">{{SECTION.media_dimensions}}</small>
                            </div>

                            <!--<small *ngIf="imageSizeError[section_index][field.name]  && field.type=='file'"
                              class="text-danger font-14">The image size must not exceed 3MB</small> -->
                            <small
                              *ngIf=" !forms[section_index].controls[field.name].valid && forms[section_index].controls[field.name].touched "
                              class="text-danger font-14">You must enter {{ field.label }}.</small>
                            <small *ngIf=" backendErrors[section_index][field.name]"
                              class="text-danger font-14">{{backendErrors[section_index][field.name]}}</small>
                          </div>
                        </div>
                      </div>

                    </div> <!-- End Of Render Arabic Fields -->

                    <div class="sub-btn d-flex justify-content-center my-3">
                      <button class="btn btn-danger w-25" (click)="openDialog(section_index)">Save Section</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>

</section>
